export default function randomImage() {
    // 1. Alle relevanten Elemente sammeln
    const bilder = document.querySelectorAll('.js-random-image > *');

    // Prüfen, ob Elemente gefunden wurden
    if (bilder.length === 0) {
        //console.warn("Keine Elemente mit der Klasse '.js-random-image' gefunden.");
    } else {
        document.querySelector('body').classList.add("random-image-init");
        // 2. Einen zufälligen Index generieren
        // Math.floor(Math.random() * bilder.length) gibt eine zufällige Ganzzahl zwischen 0 und (Anzahl der Elemente - 1) zurück
        const zufallsIndex = Math.floor(Math.random() * bilder.length);

        // 3. Alle Elemente durchlaufen und die Sichtbarkeit steuern
        bilder.forEach((element, index) => {
            if (index === zufallsIndex) {
                // Das zufällig ausgewählte Element anzeigen
                element.style.display = 'flex'; // Oder 'inline-block', 'flex', etc., je nach ursprünglichem Elementtyp
            } else {
                // Alle anderen Elemente ausblenden
                element.style.display = 'none';
            }
        });

        // Optional: Das ausgewählte Element in der Konsole anzeigen
        //console.log('Zufällig ausgewähltes Element:', bilder[zufallsIndex]);
    }
}